// extracted by mini-css-extract-plugin
module.exports = {"OASIS-1":"OASIS1_OASIS-1__2tgcq","fadeIn":"OASIS1_fadeIn__eijPt"};